import { SubForm } from '@/types/subform';

import { EntityType } from '../types/EntityType';
import {
  defaultValues,
  Fields,
  NamespaceType,
  Props,
  STRUCTURED_ASSETS_SUBFORM_NAMESPACE,
  StructuredAssetsSubformProperties,
  VariantType,
} from './StructuredAssetsSubform.types';
import { UI } from './StructuredAssetsSubform.UI';

export class StructuredAssetsSubform
  implements
    SubForm<
      StructuredAssetsSubformProperties,
      Fields,
      NamespaceType,
      VariantType,
      { entityType: EntityType }
    >
{
  FormComponent: (props: Props) => JSX.Element;
  defaultValues: StructuredAssetsSubformProperties;
  namespace: NamespaceType;

  constructor() {
    this.FormComponent = UI;
    this.defaultValues = defaultValues;
    this.namespace = STRUCTURED_ASSETS_SUBFORM_NAMESPACE;
  }
}
